import { useDispatch } from "react-redux";
import { openWindow } from "src/redux/actions/Mosaic.Actions";
// Material-UI
import { Grid, Typography, Button, Theme } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v1 } from "uuid";
import { IconButton } from "src/components/IconButton/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// Selected Day items
//! These have been re-added to the selected crew/day context menu
// import { ManageNFAs } from "./AddEvents/ManageNFAs";
// import { ManageLMs } from "./AddEvents/ManageLMs";

interface ITimelineAddEvents {
  timelineContainer?: HTMLDivElement;
  windowId: string;
  path: string[];
  setTabValue: React.Dispatch<React.SetStateAction<string | boolean>>;
}

const timelineAddEventsStyles = (theme: Theme): any => ({
  display: "flex",
  padding: "10px",
  flexWrap: "wrap",
  "& .build_button": { margin: "0 5px" },
  // Selection fields (custom styles)
  "& .fulldayevent_selection": { width: 330, "& .input_control label": { width: "auto", margin: "0px 10px" } },
  "& .blm_selection": { width: 300, "& .input_control label": { width: "auto", margin: "0px 10px" } },
  "& .crew_blm_note": { width: 300, "& .input_control label": { width: "auto" } },
  // Slight change of styling for input labels
  "& .input_control label": theme.typography.subtitle1,
});

/**
 * CREW SCHEDULE ADD EVENT TOOL
 * Displays a series of quicklinks to the flight builder component so that users can jump straight to the type of timeline event builder they want.
 */
export const CrewScheduleAddEvents = (props: ITimelineAddEvents): JSX.Element => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { path, setTabValue } = props;

  const handleCreatePairing = (): void => {
    dispatch(
      openWindow(
        "New Pairing",
        "PairingEditorWindow",
        path,
        {
          pairingId: `new_${v1()}`,
          crewMember: null,
          selectedTime: null,
        },
        null
        //"content"
      )
    );
  };

  return (
    <Grid sx={timelineAddEventsStyles(theme)} container alignItems="center">
      <Grid container alignItems="center" style={{ width: "auto", marginRight: 10 }}>
        <IconButton style={{ paddingBottom: "4px", marginRight: "20px" }} onClick={() => setTabValue(false)}>
          <VisibilityOffIcon fontSize="small" />
        </IconButton>
        <Typography variant="subtitle1" className="body_text">
          Create
        </Typography>
        <Button
          id={"add_flights_btn"}
          className="build_button"
          variant="outlined"
          onClick={() => handleCreatePairing()}
        >
          Pairing
        </Button>
      </Grid>
    </Grid>
  );
};
